import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';

import { MtnaTrackByPropertyPipeModule } from '@mtna/lib-ui';

import { RdsColumnToggleComponent } from './column-toggle.component';
import { RdsDataDictionaryTableComponent } from './data-dictionary-table.component';

const COMPONENTS = [RdsDataDictionaryTableComponent, RdsColumnToggleComponent];
@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatTableModule,
    MtnaTrackByPropertyPipeModule
  ],
  declarations: [COMPONENTS],
  exports: [COMPONENTS]
})
export class RdsDataDictionaryTableModule {}

export * from './column-toggle.component';
export * from './data-dictionary-table-column.model';
export * from './data-dictionary-table.component';
